package org.hs_soft.runmynesto.data.api_datasource.options.price_category

import kotlinx.serialization.json.Json
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.encodeToJsonElement
import kotlinx.serialization.json.put
import kotlinx.serialization.json.putJsonObject
import org.hs_soft.runmynesto.data.api_datasource.RequestManager
import org.hs_soft.runmynesto.domain.ApiClient
import org.hs_soft.runmynesto.domain.config.Errors
import org.hs_soft.runmynesto.domain.model.home.options.price_category.PriceCategoryModel
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_options.PriceLevelModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.price_category.UpdatePricesCategoryRepository
import org.hs_soft.runmynesto.domain.util.ApiUtils

class UpdatePriceCategoryRepositoryImpl (
    private val apiClient: ApiClient,
    private val requestManager: RequestManager,
): UpdatePricesCategoryRepository {

    override suspend fun updatePriceCategory(
        data:List<String?>
    ): PriceLevelModel {
        val abortController = requestManager.createController()

        val graphQLQuery = buildJsonObject {
            put("query", """
                mutation updatePriceLevels(${'$'}fields: AppConfigAdditionalInput) {
                  cashAssist {
                    updateAppConfigAdditional(fields:${'$'}fields) {
                      ${ApiUtils.Field.priceLevels} 
                    } 
                  }
                }



            """.trimIndent())

            putJsonObject("variables") {
                putJsonObject("fields") {
                   put("priceLevels", Json.encodeToJsonElement(data))
                }
            }
        }

        val result = apiClient.requestResult(
            graphQLQuery = graphQLQuery,
            resource = ApiUtils.Cognito.API_URL,
            abortController = abortController,
        )

        return if (result != null) {
            Json.decodeFromString(result.decodeToString())
        } else {
            throw Exception(Errors.timeoutErr)

        }


    }

}
